import { validators, z } from "@verde/utils";

export const bulkSchema = z.object({
  mode: z.literal("bulk"),
  file: z.instanceof(File, {
    message: "Campo obrigatório.",
  }),
});

export const singleSchema = z.object({
  mode: z.literal("single"),
  operation_id: z.string(),
  operation_value: z.number(),
  client_document_number: z
    .string()
    .nonempty()
    .refine(validators.isCPFOrCNPJ, "CPF/CNPJ inválido"),
  client_name: z.string().optional(),
  due_date: z.coerce.date(),
});

export const schema = z
  .object({
    investment_fund_id: z.number(),
    mode: z.enum(["bulk", "single"]),
  })
  .and(z.discriminatedUnion("mode", [bulkSchema, singleSchema]));

export type Schema = z.input<typeof schema>;
export type BulkSchema = z.input<typeof bulkSchema>;
export type SingleSchema = z.input<typeof singleSchema>;
